import * as React from 'react';

import { translate } from '~l10n/client';
import { Decimal128 } from 'proposal-decimal';

import { ContactSalesEventAdapter } from '~analytics/adapters/ContactSalesEventAdapter';
import { SmallLinkButton } from '~shared/components/buttons';
import {
  useSelectedTeamPermissionQuery,
  useShowShowbieCompleteOffer,
  useTypeFormLink,
} from '~teacher/components/PricingTable/hooks';
import { formatPrice } from '~teacher/components/PricingTable/PriceComponent/helpers';
import { MonthSeatPrice } from '~teacher/components/PricingTable/PriceComponent/MonthSeatPrice';

const ORGANIZATION_PRICE_MONTHLY = new Decimal128(1440).divide(
  new Decimal128(100)
);
const ORGANIZATION_PRICE_YEARLY = ORGANIZATION_PRICE_MONTHLY.multiply(
  new Decimal128(12)
);

export function OrganizationPriceComponent() {
  const teamPermissionQuery = useSelectedTeamPermissionQuery();
  const showShowbieCompleteOfferQuery = useShowShowbieCompleteOffer();
  const offerShowbieCompletePrice = showShowbieCompleteOfferQuery.data;

  const medium = offerShowbieCompletePrice
    ? 'socrative-complete-price'
    : 'socrative-complete-no-price';
  const typeFormLink = useTypeFormLink({ medium: medium });

  return (
    <>
      <MonthSeatPrice price={ORGANIZATION_PRICE_MONTHLY} />
      <div className={'text-base font-sans  text-blue-900 leading-8'}>
        {translate('{0} Annually').format(
          formatPrice(ORGANIZATION_PRICE_YEARLY)
        )}
      </div>
      <div className={'text-base font-sans text-blue-900 leading-8 pb-4'}>
        {translate('Starting at {0} Seats').format('10')}
      </div>
      <div className="row-start-6">
        {teamPermissionQuery.data?.canOpenStripeCheckout ? (
          <SmallLinkButton
            href={typeFormLink.data}
            target="_blank"
            appearance="default"
            className={'w-full flex justify-center'}
            onClick={() => {
              new ContactSalesEventAdapter({
                form_source: 'typeform',
                source: medium,
              }).sendAnalytics();
            }}
          >
            {translate('Contact Sales')}
          </SmallLinkButton>
        ) : null}
      </div>
    </>
  );
}
